import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import { toast } from "react-toastify";
import { FIELD_LABELS } from "./bookingStepperUtils";

// Formik silently does nothing when validation fails on submit. With the form split into
// steps, an invalid field the user cannot see reads as "the button is broken" - so surface
// the first error and take them to the step (and field) that holds it.
//   onErrorField(field)   switches to that field's step and focuses it
const SubmitErrorReporter = ({ onErrorField }) => {
  const { submitCount, errors, values } = useFormikContext();
  const reportedRef = useRef(0);

  useEffect(() => {
    if (submitCount === 0 || submitCount === reportedRef.current) return;

    const fields = Object.keys(errors || {});
    if (fields.length === 0) return;

    reportedRef.current = submitCount;

    const field = fields[0];
    const rawError = errors[field];
    const message = typeof rawError === "string" ? rawError : `${FIELD_LABELS[field] || field} is invalid`;

    toast.error(message);
    console.warn("Booking form validation failed:", errors);
    console.warn("Booking form values at time of failed submit:", JSON.stringify(values));

    onErrorField?.(field);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount, errors]);

  return null;
};

export default SubmitErrorReporter;
